import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [sosData, setSosData] = useState(null);
  const [dmsData, setDmsData] = useState(null);

  const contextValue = useMemo(
    () => ({
      sosData,
      setSosData,
      dmsData,
      setDmsData,
    }),
    [sosData, dmsData]
  );

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
};

SocketProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSocket = () => useContext(SocketContext);
